import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Container } from 'reactstrap';

export interface NoContentModalRef {
  openModal: () => void;
  closeModal: () => void;
}

const NoContentModal = forwardRef<NoContentModalRef, any>((_, ref) => {
  const [modal, setModal] = useState(false);

  useImperativeHandle(ref, () => ({
    openModal() {
      setModal(true);
    },
    closeModal() {
      setModal(false);
    },
  }));

  return (
    <Modal isOpen={modal} toggle={() => setModal(!modal)}>
      <Container fluid className="text-center">
        <Icon name="information" size={45} />
        <h1 className="text-dark fs-20 mt-3 mb-4">No hay resultados</h1>

        <div className="d-flex justify-content-around" style={{ gap: 10 }}>
          <div className="flex-fill">
            <Button
              className="w-100"
              outlined
              text={'cancelar'}
              onClick={() => {
                setModal(false);
              }}
            />
          </div>
          <div className="flex-fill">
            <Button
              className="w-100"
              text={'confirmar'}
              onClick={() => {
                setModal(false);
              }}
            />
          </div>
        </div>
      </Container>
    </Modal>
  );
});

export default NoContentModal;
